(function () {
  'use strict';

  class EbCertVault extends HTMLElement {
    connectedCallback() {
      this.medallions = [...this.querySelectorAll('[data-vault-flip]')];
      this.medallions.forEach((m) => {
        m.addEventListener('click', () => this.toggle(m));
      });
    }

    toggle(m) {
      const on = m.getAttribute('aria-pressed') === 'true';
      m.setAttribute('aria-pressed', on ? 'false' : 'true');
    }
  }

  if (!customElements.get('eb-cert-vault')) {
    customElements.define('eb-cert-vault', EbCertVault);
  }
})();
